<template>
  <div class="home-container">
    <list v-model="isLoading"
          :finished="dataLoadingFinished"
          loading-text=" "
          finished-text="到底了"
          @load="InitItemFeed"
    >
      <MovieItemListGrid v-if="isGrid" :data="dataList"></MovieItemListGrid>
      <MovieItemList v-else :data="dataList"></MovieItemList>
    </list>
    <Empty v-if="dataLoadingFinished && !totalCount"></Empty>
  </div>
</template>

<script>
  import {Toast, List, Empty} from "vant"
  import MovieItemList from "@/components/ugc_item/MovieItemList.vue"
  import MovieItemListGrid from "@/components/ugc_item/MovieItemListGrid.vue"

  export default {
    name: "MovieItemFeed",
    components: {
      MovieItemList, MovieItemListGrid, Toast, List, Empty
    },
    props: {
      listType: {
      },
      listStyle: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        currentPage: 0,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        isLoading: false,
        dataLoadingFinished: false,

        needShowDataList: true,
        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        let curPage = this.$route.query.page
        if (curPage) {
          this.currentPage = parseInt(curPage)
        } else {
          this.currentPage = 0
        }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
      },

      async InitItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }
        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            Toast("未登录")
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            Toast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        let params = {
          page: this.currentPage,
          list_type: this.listType,
        }
        this.$router.push({query: params})
        this.initParams()
        this.InitItemFeed()
      },
    },
    computed: {
      isGrid() {
        return this.listStyle === 'grid'
      }
    },
    watch: {
      listType() {
        this.currentPage = 0
        this.onChange()
      },
    }
  };
</script>

<style scoped>
  .home-container {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>
